import axios from "axios";
import { devWarn } from "@/lib/logger";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

client.interceptors.response.use(
  (r) => r,
  async (err) => {
    // Try one refresh on 401 (except on the auth endpoints themselves)
    const original = err.config || {};
    if (
      err.response?.status === 401 &&
      !original._retry &&
      !(original.url || "").includes("/auth/")
    ) {
      original._retry = true;
      try {
        await client.post("/auth/refresh");
        return client(original);
      } catch (refreshErr) {
        // Refresh failed → the original 401 stands. Let the caller handle it.
        devWarn("Silent token refresh failed:", refreshErr?.message || refreshErr);
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) =>
        e && typeof e.msg === "string"
          ? `${(e.loc || []).slice(1).join(".")}: ${e.msg}`
          : JSON.stringify(e)
      )
      .join("  •  ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default client;
